import { EventDispatcher } from "../Events/EventDispatcher";
import * as ControlFactory from "../Common/ControlFactory";
import { app } from "../Frame/App";
import { FixedDialog, DialogResult } from "./FixedDialog";
import { PagePopup } from "./PagePopup";
import { MappingImportedMeasure } from "../Components/MappingMeasure/MappingImportedMeasure";

export class FileUploadControl {
    public notAllowedExtensionEvent: EventDispatcher<FileUploadControl, string>;
    public fileUploadedEvent: EventDispatcher<FileUploadControl, any>;
    public fileDeletedEvent: EventDispatcher<FileUploadControl, any>;
    public antiforgeryToken: string;
    public file: File;
    public deleteIsController: boolean = true;

    constructor(
        public element: HTMLElement,
        public ajaxURL: string,
        protected uploadImmediatly?: boolean,
        protected allowedExtensions?: string,
        public ajaxDeleteUrl?: string,
        public uploadedFilesType?: string
    ) {
        this.notAllowedExtensionEvent = new EventDispatcher<FileUploadControl, string>();
        this.fileUploadedEvent = new EventDispatcher<FileUploadControl, any>();
        this.fileDeletedEvent = new EventDispatcher<FileUploadControl, any>();
    }

    guid: string;

    init(existingFile?: string, existingFileId?: number) {
        this.element.innerHTML = "";

        // text
        let div = ControlFactory.createDiv("drop-text");
        div.className = "drop-or-browse-text";

        if (existingFile) {
            div.innerHTML = Resources.Common.fileUploadChange + " ";
        } else {
            div.innerHTML = Resources.Common.fileUploadDropOr + " "; // Drop file here to import or
        }
        // browse
        let selectFile = ControlFactory.createSpan("browse-file doc-upload");
        selectFile.innerHTML = Resources.Common.fileUploadSearch; // "Search"
        div.appendChild(selectFile);
        this.element.appendChild(div);

        // upload input
        let input = document.createElement("input");
        input.className = "file";
        input.type = "file";
        input.style.display = "none";
        this.element.appendChild(input);

        // browse-click
        selectFile.addEventListener("click", () => {
            input.click();
        });

        // file-name (place holder)
        let fileNameDiv = ControlFactory.createDiv("uploaded-file-name");
        fileNameDiv.className = "uploaded-file-name mb-3";
        if (existingFile) {
            this.file = new File([], existingFile, undefined);
            fileNameDiv.innerText = existingFile;
            if (existingFileId) {
                fileNameDiv.setAttribute("data-existing-file-id", existingFileId.toString());
            }
        } else {
            fileNameDiv.style.display = "none";
        }

        this.element.appendChild(fileNameDiv);

        if (this.file) {
            this.getTrashIcon(fileNameDiv);
        }

        // upload button
        let upload = ControlFactory.createDiv("doc-upload");
        upload.className = "btn btn-mso btn-save btn-upload";
        upload.innerHTML = Resources.Common.fileUploadImport; // "Import"
        upload.style.display = "none";
        this.element.appendChild(upload);

        // upload files
        upload.addEventListener("click", () => {
            this.uploadFile();
        });


        
        // File input change
        input.addEventListener("change", () => {
            let files = input.files;
            for (var i = 0; i < files.length; i++) {
                this.file = files[i];
            }
            let extension = this.file.name.split('.').pop();
            if (this.allowedExtensions && this.allowedExtensions.split(',').indexOf(extension) == -1) {
                this.notAllowedExtensionEvent.dispatch(this, extension);
                this.init();
            }
            else {
                this.showFileOption(false);
                if (this.uploadImmediatly) {
                    this.uploadFile();
                }
            }
        });

        // On drag-drop
        if (!this.element.hasAttribute("data-doc-initialized")) {
            // see https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/File_drag_and_drop
            this.element.addEventListener("drop", (ev: DragEvent) => {

                // Prevent default behavior (Prevent file from being opened)
                ev.preventDefault();

                if (ev.dataTransfer.items) {
                    for (var i = 0; i < ev.dataTransfer.items.length; i++) {
                        // If dropped items aren't files, reject them
                        if (ev.dataTransfer.items[i].kind === 'file') {
                            this.file = ev.dataTransfer.items[i].getAsFile();
                            let extension = this.file.name.split('.').pop();
                            if (!this.allowedExtensions || this.allowedExtensions.split(',').indexOf(extension) != -1) {
                                this.showFileOption(false);
                                if (this.uploadImmediatly) {
                                    this.uploadFile();
                                }
                            }
                            else {
                                this.notAllowedExtensionEvent.dispatch(this, extension);
                            }
                        }
                    }
                }
                this.removeDragData(ev);
            });

            this.element.addEventListener("dragover", (e: DragEvent) => {
                e.preventDefault();
            });
        }

        this.element.setAttribute("data-doc-initialized", "true");

       

    }

    protected uploadFile = () => {

        let _ajaxURL = this.ajaxURL;

        var formData = new FormData();
        formData.append("files", this.file);
        if (this.uploadedFilesType) {
            formData.append("filesType", this.uploadedFilesType);
        }

        let oldMessageElement: HTMLElement = document.body.querySelector(".doc-row");
        if (oldMessageElement != null) {
            oldMessageElement.remove();
   /*         this.element.removeChild(oldMessageElement);*/
        }

        let progress = ControlFactory.createProgress(0, 0, 100);
        this.element.appendChild(progress);
        this.showFileOption(true);

        // close button
        let close = ControlFactory.createDiv("doc-upload-close");
        close.className = "btn btn-mso btn-save btn-close";
        close.innerHTML = Resources.Common.close; // "Close"
        close.style.display = "none";
        this.element.appendChild(close);

        // close after import
        close.addEventListener("click", () => {
            this.close();
        });

        // if there is an existing file, delete it first.
        let fileNameDiv = this.element.querySelector(".uploaded-file-name") as HTMLElement;
        let attributeId = fileNameDiv.getAttribute("data-existing-file-id");
        if (attributeId) {
            this.ajaxRequestDelete(attributeId, true);
        }


        $.ajax({
            url: app.resolveUrl(_ajaxURL),
            data: formData,
            processData: false,
            contentType: false,
            type: "POST",
            xhr: function () {
                var xhr = new XMLHttpRequest();
                xhr.upload.addEventListener("progress", function (evt) {
                    if (evt.lengthComputable) {
                        var newProgress = Math.round((evt.loaded / evt.total) * 100);
                        ControlFactory.updateProgress(progress, newProgress);
                    }
                }, false);
                return xhr;
            },
            beforeSend: (request) => {
                if (this.antiforgeryToken) {
                    request.setRequestHeader("RequestVerificationToken", this.antiforgeryToken);
                }
            },
            success: (data) => {
               //29.07.2021 : AB Hack check if data is serialized object from import measure
                    this.showFileOption(false);
                    let result = typeof data === "string" ? JSON.parse(data) : data;
                    if (result.isImportSuccess === true) {
                        document.querySelector('#fileUploadPart').innerHTML = '';
                        this.init();
                        this.DisplayMeasureMapping(data);
                    }
                    if (result) {
                        if (result.data && result.data.id) {
                            fileNameDiv.setAttribute("data-existing-file-id", result.data.id);
                        }
                        else if (result.id) {
                            fileNameDiv.setAttribute("data-existing-file-id", result.id);
                        }
                    }

                    // set the new file.
                    if (result.state == 0) {

                        progress.innerHTML = "";
                        progress.classList.remove("progress");
                        progress.classList.add("doc-row");
                        progress.classList.add("mb-3");
                        progress.innerHTML = result.message;
                        this.fileUploadedEvent.dispatch(this, result);

                        let btnUploadDiv = this.element.querySelector(".btn-upload") as HTMLElement;
                        btnUploadDiv.style.display = "none";

                        if (window.location.pathname == app.resolveUrl("~/StimulsoftReports")) {
                            let btnCloseDiv = this.element.querySelector(".btn-close") as HTMLElement;
                            btnCloseDiv.style.display = "block";
                        }
                    }
                    else {
                        progress.innerHTML = "";
                        progress.classList.remove("progress");
                        alert(result.message);
                    }
            }
        });
    }

   
    protected close() {
        location.reload();
        PagePopup.getActivePopup().close("cancel");
    }

    protected showFileOption = (loading: boolean) => {

        let fileNameDiv = this.element.querySelector(".uploaded-file-name") as HTMLDivElement;
        fileNameDiv.innerHTML = "";
        fileNameDiv.style.display = "block";

        let spanName = document.createElement("span");
        fileNameDiv.appendChild(spanName);

        let uploadBtn = this.element.querySelector(".btn-upload");
        (<HTMLElement>uploadBtn).style.display = "none";

        if (loading) {
            spanName.innerHTML = (<string>Resources.Common.fileUploadUploadingOfFile).format(this.file.name);
        }
        else {
            spanName.innerHTML = this.file.name;
            this.getTrashIcon(fileNameDiv);


            (<HTMLElement>uploadBtn).style.display = "block";

            let fileTextDiv = this.element.querySelector(".drop-or-browse-text");
            (<HTMLDivElement>fileTextDiv).style.display = "none";
        }
    }

    protected removeDragData = (ev) => {
        if (ev.dataTransfer.items) {
            // Use DataTransferItemList interface to remove the drag data
            ev.dataTransfer.items.clear();
        } else {
            // Use DataTransfer interface to remove the drag data
            ev.dataTransfer.clearData();
        }
    }

    protected getTrashIcon = (fileNameDiv: HTMLDivElement) => {
        let delIcon = ControlFactory.createFontAwesome("trash", "doc-delete");
        delIcon.addEventListener("click", () => {
            new FixedDialog(delIcon).showYesNo(Resources.Common.fileUploadDeleteConfirm, null, null, 10000).done((result) => {
                if (result == DialogResult.Yes) {
                    let idAttribute = fileNameDiv.getAttribute("data-existing-file-id");
                    if (idAttribute) {
                        this.ajaxRequestDelete(idAttribute);
                    }
                    this.init();
                }
            });
        });
        fileNameDiv.appendChild(delIcon);
    }

    protected ajaxRequestDelete(idAttribute: string, exchangeFile: boolean = false) {
        $.ajax({
            url: app.resolveUrl(this.ajaxDeleteUrl + (this.deleteIsController ? "/" + idAttribute : "")),
            processData: false,
            contentType: false,
            type: "GET",
            async: false,
            success: () => {
                // If a file is just being replaced, no need to fire the event.
                if (!exchangeFile) {
                    this.fileDeletedEvent.dispatch(this, null);
                }
            }
        });
    }

    private DisplayMeasureMapping(resultUrl: string) {

        new MappingImportedMeasure(resultUrl).show();
    }
}
